var SessionTimerModalState = /** @class */ (function () {
    function SessionTimerModalState() {
        this.timeOut = false;
        this.expiredTimeOut = false;
        this.doNoRedirection = false;
    }
    return SessionTimerModalState;
}());
export default SessionTimerModalState;
//# sourceMappingURL=SessionTimerModalState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/SessionTimerModal/SessionTimerModalState.js
// module id = 1730
// module chunks = 8